import React, { Fragment, Component } from "react";
import CKEditors from "react-ckeditor-component";
// import Image from "react-ckeditor-component/lib/index";
// import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
// import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
// import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
// import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
// import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
// import Heading from "@ckeditor/ckeditor5-heading/src/heading";
class Editor1 extends Component {
  constructor(props) {
    super(props);
    this.updateContent = this.updateContent.bind(this);
    this.state = {
      content: this.props.productDescription || "content",
    };
  }

  updateContent(newContent) {
    this.setState({
      content: newContent,
    });
  }

  onChange(evt) {
    const { onChangeDescription } = this.props;
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent,
    });
    onChangeDescription(newContent);
  }

  render() {
    return (
      <CKEditors
        activeclassName="p10"
        content={this.state.content}
        // removePlugins={["Blockquote", "Image", "List"]}
        // config={{ removePlugins: ["Image"] }}
        // config={{
        //   plugins: [Essentials, Paragraph, Bold, Italic, Heading],
        //   toolbar: ["heading", "|", "bold", "italic", "|", "undo", "redo"],
        // }}
        events={{
          blur: this.onBlur,
          afterPaste: this.afterPaste,
          change: this.onChange.bind(this),
        }}
      />
    );
  }
}

export default Editor1;
